import dsBridge from "dsbridge";
const callbackFunctionName = "__JS_CALLBACK__";
// const isProdEnv = process.env.NODE_ENV === 'production';
const isProdEnv = true; // 临时测试

// 获取终端类型和版本(1.0.0)
export function getAppInfo() {
  if (isProdEnv) {
    if (isFlutterMode()) {
      return commonBridge("jsGetAppInfo");
    }
    return new Promise((resolve) => {
      // 异步方法
      // dsBridge.call('jsGetAppInfo', {}, resolve);

      // 同步方法
      resolve(dsBridge.call("jsGetAppInfo"));
    });
  } else {
    return Promise.resolve({
      code: 0,
      message: "ok",
      data: {
        origin: "1", // 终端类型，安卓为1，iOS为2,
        // version: '3.3.0',
        version: "3.0.1",
        flavor: "onething",
      },
    });
  }
}

export function genRandomUUID() {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

function commonBridge(name, data = {}, selfCallback = () => {}) {
  const callback = `${callbackFunctionName}_${genRandomUUID()}`;
  return new Promise((resolve) => {
    window[callback] = function (res) {
      resolve(res);
      window[callback] = undefined;
      typeof selfCallback === "function" && selfCallback(res);
    };
    window.WebBridgeChannel.postMessage(
      JSON.stringify({
        method: name,
        params: data,
        callback: callback,
      })
    );
  });
}

export function isFlutterMode() {
  return typeof window.WebBridgeChannel !== "undefined";
}

// 关闭当前H5页面 (1.0.0+)
export function jsCloseWebPage() {
  if (isFlutterMode()) {
    return commonBridge("jsCloseWebPage");
  }
}

// H5打开分享弹窗 (1.0.0+)
export function jsOpenShareDialog(data, callback = () => {}) {
  if (isFlutterMode()) {
    return commonBridge("jsOpenShareDialog", data, callback);
  }
}

// 打开原生页面
export function jsOpenPage(data) {
  if (isFlutterMode()) {
    return commonBridge("jsOpenPage", data);
  }
}

/**
 * 原生上报埋点数据(1.0.0+)
 * @param {Object} data
 *  - event_id	事件id
 *  - attributes = {} 上报属性
 */
export function reportNative(data) {
  console.log("report: ", data);
  if (isFlutterMode()) {
    return commonBridge("jsAnalyticsEvent", data);
  }
}

/**
 * 配置当前H5页面信息(1.0.0+)
 * @param {Object} data
 *  - module 页面所属模块,
    - page_name 当前页面名称
 */
export function configWebPageInfo(data) {
  console.log("report: ", data);
  if (isFlutterMode()) {
    return commonBridge("jsConfigWebPageInfo", data);
  }
}
